import { contentfulClient } from "@/utils/contentful";
import WhoWeServeTemplate, {
  WhoWeServePageFields,
} from "@/components/WhoWeServeTemplate/WhoWeServeTemplate";

interface YouthSportsPageProps {
  fields: WhoWeServePageFields;
}

const Page = ({ fields }: YouthSportsPageProps) => {
  return (
    <WhoWeServeTemplate
      fields={fields}
      heroBackgroundImage="/images/youth-sports-management-software.svg"
      featureCardIconStyle="enhanced"
    />
  );
};

export const getStaticProps = async () => {
  const response = await contentfulClient.getEntries({
    content_type: "organizationTypePage",
    "fields.slug": "youth-sports-management-software",
  });

  if (!response.items.length) {
    return { notFound: true };
  }

  return {
    props: {
      fields: response.items[0].fields,
    },
  };
};

export default Page;
